import store from 'stores'

// const timer = 2000
const error = (message = 'ขออภัยพบปัญหาบ้างอย่าง') => {
  store.message.error({
    message,
  })
}

const warning = (message) => {
  store.messager.warning({
    message,
  })
}

const success = (message = 'บันทึกสำเร็จ') => {
  store.message.success({
    message,
  })
}

export const message = {
  error,
  warning,
  success,
}
